import { render, staticRenderFns } from "./relatorioDAIRRetrato.vue?vue&type=template&id=3e70f92e"
import script from "./relatorioDAIRRetrato.vue?vue&type=script&lang=js"
export * from "./relatorioDAIRRetrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports